module.exports = __webpack_public_path__ + "img/absolut-second-block-img.fb734aa3.png";